import { BASE_ADMIN_V2_PATH } from '../../shared/admin/constants/path.constants';

const ADMIN_DELIVERY_ZONES_APP_ROOT = `${BASE_ADMIN_V2_PATH}/delivery-zones`;

export const ADMIN_DELIVERY_ZONES_APP_PATHS = {
  DELIVERY_ZONES_LIST: `${ADMIN_DELIVERY_ZONES_APP_ROOT}`,
  DELIVERY_ZONE_DETAILS: `${ADMIN_DELIVERY_ZONES_APP_ROOT}/:deliveryZoneId`,
  DELIVERY_ZONE_DETAILS_PATH: (deliveryZoneId: string) => `${ADMIN_DELIVERY_ZONES_APP_ROOT}/${deliveryZoneId}`,
};
